

import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

window.addEventListener('frame-ready', init)

function init() {

    {
        const PAGE = document.querySelector('.ProductPage')
        if(!PAGE) return

        const hero = PAGE.querySelector('.offset-hero');
        const header = PAGE.querySelector('.offset-hero .wave-content .container')
        const wave = PAGE.querySelector('.offset-hero .wave')
        const content = [
            PAGE.querySelector('.product-image'),
            PAGE.querySelector('.product-details'),
            PAGE.querySelector('.nutrition-details')
        ]

        const timeline = gsap.timeline({
            ease: 'power2.inOut'
        })

        if(hero.classList.contains('has-background')) {
            timeline.to(header, {translateY: 0, opacity: 1})
                .to(content, {
                    stagger: {
                        each: 0.1,
                    },
                    opacity: 1,
                    translateY: 0,
                }, "<")
        } else {
            timeline.to(header, {translateY: 0, opacity: 1})
                .to(wave, {scale: 1, rotate: 180}, "<")
                .to(content, {
                    stagger: {
                        each: 0.1,
                    },
                    opacity: 1,
                    translateY: 0,
                }, "<")
        }
    }
}
